import { Box } from "@mui/material";
import Header from "../../../components/Header";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getVariationLoading,
  getVariations,
} from "../../../features/variationSlice";
import {
  getTypeVariationError,
  getTypeVariationStatus,
  getTypeVariationSuccess,
  modifyTypeVariation,
} from "../../../features/typeVariationSlice";
import { updateStatus } from "../../../features/typeSlice";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import VariationForm from "./variationForm";
import BackButton from "../../../components/backButton";
import { useTranslation } from "react-i18next";

const ModifyTypeVariation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { restaurantId } = useRestaurant();
  const data = location.state.typeVariation;
  const status = useSelector(getTypeVariationStatus);
  const error = useSelector(getTypeVariationError);
  const loading = useSelector(getVariationLoading);
  const success = useSelector(getTypeVariationSuccess);

  const initialValues = {
    name: data.name || "",
    label: data.name || "",
    message: data.name || "",
    variations: data?.variations.map((variation) => variation._id) || [],
  };

  useEffect(() => {
    dispatch(getVariations(restaurantId));
  }, [dispatch, restaurantId]);

  const handleFormSubmit = (values) => {
    dispatch(
      modifyTypeVariation({
        body: {
          name: values.name,
          label: values.label,
          description: values.message,
          variations: values.variations,
        },
        typeVariationId: data._id,
        restaurantId,
      })
    );
  };

  useEffect(() => {
    if (status === "modifySuccess") {
      toast.success(success);
      dispatch(updateStatus());
      navigate("/typeVariation");
    } else if (status === "modifyError") {
      toast.error(error);
    }
  }, [status, error, dispatch, navigate, success]);

  return (
    <Box m="20px" className="main-application">
      <BackButton/>
      <Header title={t("headers.editTypeVariation")} subtitle={t("headers.editTypeVariationSub")} />
      <VariationForm
        buttonText={t("common.edit")}
        handleFormSubmit={handleFormSubmit}
        initialValues={initialValues}
        loading={loading}
      />
    </Box>
  );
};

export default ModifyTypeVariation;
